// external
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models
import {
	GET_GO_TO_CART_OPEN,
	SET_GO_TO_CART_OPEN,
	GET_CURRENT_MXR_RETAILER,
	GET_MXR_KROGER_CHECKOUT_REPORT,
	SEND_REPORT,
} from '@/store/types';
import MxrRetailer from '@/interfaces/MxrRetailer';
import { VuexAction } from '@/@types/index.d';
import { IReport } from '@/interfaces/IReport';

@Component({})
export default class GoToCart extends Vue {
	@Getter(GET_CURRENT_MXR_RETAILER) getCurrentMxrRetailer!: MxrRetailer;

	@Getter(GET_GO_TO_CART_OPEN) getGoToCartOpen!: boolean;

	@Getter(GET_MXR_KROGER_CHECKOUT_REPORT)
	getMxrKrogerCheckoutReport!: IReport;

	@Action(SET_GO_TO_CART_OPEN) setGoToCartOpen!: VuexAction<boolean>;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	get logo() {
		return this.getCurrentMxrRetailer
			? this.getCurrentMxrRetailer.Logo
			: '';
	}

	get cartUrl() {
		return this.getCurrentMxrRetailer
			? `${this.getCurrentMxrRetailer.StoreUrl}/cart`
			: '';
	}

	get label() {
		return this.getCurrentMxrRetailer
			? `Go to Your ${this.getCurrentMxrRetailer.Chain} Cart`
			: '';
	}

	checkout() {
		this.sendReport(this.getMxrKrogerCheckoutReport);
		this.close();
	}

	close() {
		this.setGoToCartOpen(false);
	}
}
